import { __extends } from "tslib";
import { utils } from '@wix/pro-gallery-lib-old';
import Wix from '../sdk/WixSdkWrapper';
import { Emitter } from './emitter';
var ON_DISPLAY_CHANGE = 'onDisplayChange';
var NavigationHelper = /** @class */ (function (_super) {
    __extends(NavigationHelper, _super);
    function NavigationHelper() {
        var _this = _super.call(this) || this;
        _this.isInitialized = false;
        _this.handleVisibilityChange = _this.handleVisibilityChange.bind(_this);
        _this.handleWixDisplayOut = _this.handleWixDisplayOut.bind(_this);
        _this.handleWixDisplayIn = _this.handleWixDisplayIn.bind(_this);
        _this.dispatchNavigationInIfNeeded =
            _this.dispatchNavigationInIfNeeded.bind(_this);
        _this.dispatchNavigationOutIfNeeded =
            _this.dispatchNavigationOutIfNeeded.bind(_this);
        _this.unsubscribeToOnDisplayChange =
            _this.unsubscribeToOnDisplayChange.bind(_this);
        _this.tabFocused = true;
        _this.wixFocused = true;
        return _this;
    }
    NavigationHelper.prototype.dispatchNavigationOutIfNeeded = function () {
        if (!this.tabFocused || !this.wixFocused) {
            this.emit(ON_DISPLAY_CHANGE, false);
        }
    };
    NavigationHelper.prototype.dispatchNavigationInIfNeeded = function () {
        if (this.tabFocused && this.wixFocused) {
            this.emit(ON_DISPLAY_CHANGE, true);
        }
    };
    NavigationHelper.prototype.handleVisibilityChange = function () {
        var hidden;
        if (typeof document.hidden !== 'undefined') {
            // Opera 12.10 and Firefox 18 and later support
            hidden = 'hidden';
        }
        else if (typeof document.msHidden !== 'undefined') {
            hidden = 'msHidden';
        }
        else if (typeof document.webkitHidden !== 'undefined') {
            hidden = 'webkitHidden';
        }
        if (document[hidden]) {
            this.tabFocused = false;
            this.dispatchNavigationOutIfNeeded();
        }
        else {
            this.tabFocused = true;
            this.dispatchNavigationInIfNeeded();
        }
    };
    NavigationHelper.prototype.handleWixDisplayIn = function () {
        this.wixFocused = true;
        this.dispatchNavigationInIfNeeded();
    };
    NavigationHelper.prototype.handleWixDisplayOut = function () {
        this.wixFocused = false;
        this.dispatchNavigationOutIfNeeded();
    };
    NavigationHelper.prototype.initializeEventListeners = function () {
        this.isInitialized = true;
        if (utils.isSSR()) {
            return;
        }
        Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, this.handleWixDisplayIn);
        Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, this.handleWixDisplayOut);
        var visibilityChange;
        if (typeof document.hidden !== 'undefined') {
            // Opera 12.10 and Firefox 18 and later support
            visibilityChange = 'visibilitychange';
        }
        else if (typeof document.msHidden !== 'undefined') {
            visibilityChange = 'msvisibilitychange';
        }
        else if (typeof document.webkitHidden !== 'undefined') {
            visibilityChange = 'webkitvisibilitychange';
        }
        window.addEventListener(visibilityChange, this.handleVisibilityChange, false);
    };
    NavigationHelper.prototype.subscribeToOnDisplayChange = function (onDisplayChange) {
        if (!this.isInitialized) {
            this.initializeEventListeners();
        }
        this.on(ON_DISPLAY_CHANGE, onDisplayChange);
    };
    NavigationHelper.prototype.unsubscribeToOnDisplayChange = function (onDisplayChange) {
        this.off(ON_DISPLAY_CHANGE, onDisplayChange);
    };
    return NavigationHelper;
}(Emitter));
export var navigationHelper = new NavigationHelper();
//# sourceMappingURL=navigationHelper.js.map